// Temporary "still building" demo banner. Delete this file + demo-banner-server.ts
// + DemoBanner.tsx + the <DemoBanner /> wiring in Nav.tsx at launch. There is no
// launch-date gate anymore — the banner shows until dismissed (cookie) or removed.

export const DEMO_BANNER_COOKIE = "et_demo_dismissed";

/**
 * Record dismissal in a cookie so the server can skip rendering the banner on
 * the next request (no first-paint flash). Client-only; no-ops on the server.
 */
export function dismissDemoBannerClient(): void {
  if (typeof document === "undefined") return;
  // 60 days is plenty for a pre-launch banner; it auto-expires at launch anyway.
  document.cookie = `${DEMO_BANNER_COOKIE}=1; Max-Age=${60 * 60 * 24 * 60}; Path=/; SameSite=Lax`;
}
